
const AppRoute = {
    BASE: "/shop",
    COURSE: "/shop/course/:id",
    POOL: "/shop/course/:id/pool/:piscinaId",
    LOGIN: "/shop/login",
    PASSWORD: "/shop/password",
    REGISTRATION: "/shop/registration",
    REGISTRATION_SENT: "/shop/registration/registration-sent",
    REGISTRATION_CONFIRM: "/shop/registration/registration-confirm",
    BOOKING: "/shop/booking/:courseId",
    CART: "/shop/cart",
    ADDRESS: "/shop/account/address",
    PAYMENT_ERROR: "/shop/errorPayment",
    ACCOUNT: "/shop/account",
    HISTORY: "/shop/history",
    COUPON: "/shop/coupon",
    ORDER: "/shop/order",
    PARTICIPANT: "/shop/account/participant",
    EDIT: "/shop/account/edit",
    ERROR: "/shop/*",
    ADMIN: "/shop/admin",
    ADMIN_COURSES: "/shop/admin/admin-courses",
    ADMIN_LEVELS: "/shop/admin/admin-levels",
    ADMIN_POOLS: "/shop/admin/admin-pools",
    ADMIN_EDIT_COURSE: "/shop/admin/admin-courses/admin-edit-course",
    ADMIN_DETAIL_COURSES: "/shop/admin/admin-courses/admin-detail-course",
    ADMIN_ORDERS: "/shop/admin/admin-orders",
    ADMIN_DETAIL_ORDERS: "/shop/admin/admin-orders/admin-detail-order",
    ADMIN_COUPONS: "/shop/admin/admin-coupons",
    ADMIN_REPORT: "/shop/admin/admin-report",
    ADMIN_EDIT_COUPON: "/shop/admin/admin-coupons/admin-edit-coupon",
    ADMIN_DETAIL_COUPON: "/shop/admin/admin-coupons/admin-detail-coupon",
}
export default AppRoute;
